module.exports = __webpack_public_path__ + "img/f2-03.7b0d6924.png";